import { render, staticRenderFns } from "./AddPages.vue?vue&type=template&id=748ae68c&scoped=true&"
import script from "./AddPages.vue?vue&type=script&lang=js&"
export * from "./AddPages.vue?vue&type=script&lang=js&"
import style0 from "./AddPages.vue?vue&type=style&index=0&id=748ae68c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748ae68c",
  null
  
)

export default component.exports